import { render, staticRenderFns } from "./AddDeliveryItemModal.vue?vue&type=template&id=a0df061c&scoped=true"
import script from "./AddDeliveryItemModal.vue?vue&type=script&lang=js"
export * from "./AddDeliveryItemModal.vue?vue&type=script&lang=js"
import style0 from "./AddDeliveryItemModal.vue?vue&type=style&index=0&id=a0df061c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0df061c",
  null
  
)

export default component.exports